import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useContext, useState } from 'react'
import {
   faUserMinus,
   faUserXmark,
   faUserAltSlash,
   faUserPlus,
} from '@fortawesome/free-solid-svg-icons'
import PropTypes from 'prop-types'
import GeneralContext from '../contexts/GeneralContext'
import FriendsContext from '../contexts/FriendsContext'
import { useNavigate } from 'react-router-dom'

function FriendCard({ state, username, name, description, image }) {
   const [userData, setUserData] = useState({
      fromUser: sessionStorage.getItem('user'),
      toUser: null,
   })

   const {
      get_userInfo,
      get_current_blocked,
      get_current_friends,
      get_current_pending,
      setCurrentTab,
      setGuestPageData,
      setShowParticipants,
      setShowComments,
      showFullSize,
      showSemiSize
   } = useContext(GeneralContext)

   const { friendsData, setFriendsData } = useContext(FriendsContext)

   const refreshData = async () => {
      const friends = await get_current_friends()
      const pending = await get_current_pending()
      const blocked = await get_current_blocked()
      setFriendsData({
         ...friendsData,
         ['pending']: pending,
         ['current']: friends,
         ['blocked']: blocked,
      })
   }

   const add_UserID = (user) => {
      fetch(
         'https://webdev.cse.buffalo.edu/hci/api/api/deekstra' +
            '/users' +
            '?attributes=%7B%0A%20%20%22path%22%3A%20%22username%22%2C%0A%20%20%22equals%22%3A%20%22' +
            user +
            '%22%0A%7D',
         {
            method: 'GET',
            headers: {
               'Content-Type': 'application/json',
               Authorization: 'Bearer ' + sessionStorage.getItem('token'),
            },
         }
      )
         .then((res) => res.json())
         .then((result) => {
            if (result) {
               console.log(result[0][0].id)
               checkPending(result[0][0].id)
            }
         })
         .catch((error) => {
            console.error('Error:', error)
         })
   }

   const block_UserID = async (user) => {
      fetch(
         'https://webdev.cse.buffalo.edu/hci/api/api/deekstra' +
            '/users' +
            '?attributes=%7B%0A%20%20%22path%22%3A%20%22username%22%2C%0A%20%20%22equals%22%3A%20%22' +
            user +
            '%22%0A%7D',
         {
            method: 'GET',
            headers: {
               'Content-Type': 'application/json',
               Authorization: 'Bearer ' + sessionStorage.getItem('token'),
            },
         }
      )
         .then((res) => res.json())
         .then((result) => {
            if (result) {
               console.log(result[0][0].id)
               block_connectionID(userData.fromUser, result[0][0].id)
            }
         })
         .catch((error) => {
            console.error('Error:', error)
         })
   }

   const block_connectionID = (user1, user2) => {
      fetch(
         'https://webdev.cse.buffalo.edu/hci/api/api/deekstra' +
            '/connections' +
            '?fromUserID=' +
            user1 +
            '&toUserID=' +
            user2,
         {
            method: 'GET',
            headers: {
               'Content-Type': 'application/json',
               Authorization: 'Bearer ' + sessionStorage.getItem('token'),
            },
         }
      )
         .then((res) => res.json())
         .then(
            (result) => {
               if (result[0][0]) {
                  console.log(result[0])
                  blockFriendHandler(result[0][0].id, user2)
               } else {
                  block_connectionID_alt(user1, user2)
               }
            },
            (error) => {
               console.log('error: username not found')
            }
         )
   }

   const block_connectionID_alt = (user1, user2) => {
      fetch(
         'https://webdev.cse.buffalo.edu/hci/api/api/deekstra' +
            '/connections' +
            '?fromUserID=' +
            user2 +
            '&toUserID=' +
            user1,
         {
            method: 'GET',
            headers: {
               'Content-Type': 'application/json',
               Authorization: 'Bearer ' + sessionStorage.getItem('token'),
            },
         }
      )
         .then((res) => res.json())
         .then(
            (result) => {
               if (result[0][0]) {
                  console.log(result[0])
                  blockFriendHandler(result[0][0].id, user2)
               } else {
                  blockFriendHandler(null, user2)
               }
            },
            (error) => {
               console.log('error: username not found')
            }
         )
   }

   const blockFriendHandler = (connection_ID, userID) => {
      if (connection_ID != null) {
         fetch(
            'https://webdev.cse.buffalo.edu/hci/api/api/deekstra' +
               '/connections/' +
               connection_ID,
            {
               method: 'PATCH',
               headers: {
                  'Content-Type': 'application/json',
                  Authorization: 'Bearer ' + sessionStorage.getItem('token'),
               },
               body: JSON.stringify({
                  fromUserID: userData.fromUser,
                  toUserID: userID,
                  attributes: {
                     status: 'blocked',
                  },
               }),
            }
         )
            .then((result) => {
               console.log('Success:')
               refreshData()
            })
            .catch((error) => {
               console.error('Error:')
            })
      } else {
         fetch(
            'https://webdev.cse.buffalo.edu/hci/api/api/deekstra' +
               '/connections',
            {
               method: 'POST',
               headers: {
                  'Content-Type': 'application/json',
                  Authorization: 'Bearer ' + sessionStorage.getItem('token'),
               },
               body: JSON.stringify({
                  fromUserID: userData.fromUser,
                  toUserID: userID,
                  attributes: {
                     status: 'blocked',
                  },
               }),
            }
         )
            .then((response) => response.json())
            .then((result) => {
               console.log('Success:', result)
               refreshData()
            })
            .catch((error) => {
               console.error('Error:', error)
            })
      }
   }

   const blockUser = async (username) => {
      //const test_username = "testfriend2"
      await block_UserID(username)
      setTimeout(() => {
         refreshData()
      }, 100)
   }

   const addFriend = (username) => {
      //const test_username = "testfriend2"
      console.log(username)
      add_UserID(username)
   }

   const checkPending = async (userID) => {
      
      
      fetch(
         'https://webdev.cse.buffalo.edu/hci/api/api/deekstra' + '/connections' + '?fromUserID=' + sessionStorage.getItem('user') + '&toUserID=' + userID,
         {
            method: 'GET',
            headers: {
               'Content-Type': 'application/json',
               Authorization: 'Bearer ' + sessionStorage.getItem('token'),
            },
         }
      )
         .then((response) => response.json())
         .then((result) => {
            console.log('Success:', result)
            console.log(result[0])
            if (result[0].length == 0) {
               console.log("Sending request")
               addFriendHandler(userID)
            }
            if (result[0][0]) {
               console.log(result[0][0])
               if (result[0][0].attributes.status != 'pending') {
                  console.log(result[0][0].attributes.pending != 'pending')
                  addFriendHandler(userID)
               }

            }
         
         })
         .catch((error) => {
            console.error('Error:', error)
         })
   }

   const addFriendHandler = async (userID) => {
      
      //TODO: Check if a request to this user is already pending

      
      fetch(
         'https://webdev.cse.buffalo.edu/hci/api/api/deekstra' + '/connections',
         {
            method: 'POST',
            headers: {
               'Content-Type': 'application/json',
               Authorization: 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({
               fromUserID: userData.fromUser,
               toUserID: userID,
               attributes: {
                  status: 'pending',
               },
            }),
         }
      )
         .then((response) => response.json())
         .then((result) => {
            console.log('Success:', result)
            refreshData()
         })
         .catch((error) => {
            console.error('Error:', error)
         })
   
      
      
   }
   const remove_UserID = (user) => {
      fetch(
         'https://webdev.cse.buffalo.edu/hci/api/api/deekstra' +
            '/users' +
            '?attributes=%7B%0A%20%20%22path%22%3A%20%22username%22%2C%0A%20%20%22equals%22%3A%20%22' +
            user +
            '%22%0A%7D',
         {
            method: 'GET',
            headers: {
               'Content-Type': 'application/json',
               Authorization: 'Bearer ' + sessionStorage.getItem('token'),
            },
         }
      )
         .then((res) => res.json())
         .then((result) => {
            console.log('this is the retrieved user', result)
            if (result) {
               console.log(result[0][0].id)
               remove_connectionID(userData.fromUser, result[0][0].id)
            }
         })
         .catch((error) => {
            console.error('Error:', error)
         })
   }

   const remove_connectionID = (user1, user2) => {
      fetch(
         'https://webdev.cse.buffalo.edu/hci/api/api/deekstra' +
            '/connections' +
            '?fromUserID=' +
            user1 +
            '&toUserID=' +
            user2,
         {
            method: 'GET',
            headers: {
               'Content-Type': 'application/json',
               Authorization: 'Bearer ' + sessionStorage.getItem('token'),
            },
         }
      )
         .then((res) => res.json())
         .then(
            (result) => {
               if (result[0][0]) {
                  console.log(result[0])
                  removeFriendHandler(result[0][0].id)
               } else {
                  remove_connectionID_alt(user1, user2)
               }
            },
            (error) => {
               console.log('error: username not found')
            }
         )
   }

   const remove_connectionID_alt = (user1, user2) => {
      fetch(
         'https://webdev.cse.buffalo.edu/hci/api/api/deekstra' +
            '/connections' +
            '?fromUserID=' +
            user2 +
            '&toUserID=' +
            user1,
         {
            method: 'GET',
            headers: {
               'Content-Type': 'application/json',
               Authorization: 'Bearer ' + sessionStorage.getItem('token'),
            },
         }
      )
         .then((res) => res.json())
         .then(
            (result) => {
               if (result[0][0]) {
                  console.log(result[0])
                  removeFriendHandler(result[0][0].id)
               } else {
                  console.log(result)
                  console.log(user1)
                  console.log(user2)
                  console.log('cant find id')
               }
            },
            (error) => {
               console.log('error: username not found')
            }
         )
   }

   const removeFriend = (username) => {
      //const test_username = "testfriend2"
      remove_UserID(username)
   }

   const removeFriendHandler = (connection_ID) => {
      fetch(
         'https://webdev.cse.buffalo.edu/hci/api/api/deekstra' +
            '/connections/' +
            connection_ID,
         {
            method: 'DELETE',
            headers: {
               'Content-Type': 'application/json',
               Authorization: 'Bearer ' + sessionStorage.getItem('token'),
            },
         }
      )
         .then((result) => {
            console.log('Success:')
            refreshData()
         })
         .catch((error) => {
            console.error('Error:')
         })
   }
   const unblock_UserID = async (user) => {
      fetch(
         'https://webdev.cse.buffalo.edu/hci/api/api/deekstra' +
            '/users' +
            '?attributes=%7B%0A%20%20%22path%22%3A%20%22username%22%2C%0A%20%20%22equals%22%3A%20%22' +
            user +
            '%22%0A%7D',
         {
            method: 'GET',
            headers: {
               'Content-Type': 'application/json',
               Authorization: 'Bearer ' + sessionStorage.getItem('token'),
            },
         }
      )
         .then((res) => res.json())
         .then((result) => {
            if (result) {
               console.log(result[0][0].id)
               unblock_connectionID(userData.fromUser, result[0][0].id)
            }
         })
         .catch((error) => {
            console.error('Error:', error)
         })
   }

   const unblock_connectionID = (user1, user2) => {
      fetch(
         'https://webdev.cse.buffalo.edu/hci/api/api/deekstra' +
            '/connections' +
            '?fromUserID=' +
            user1 +
            '&toUserID=' +
            user2,
         {
            method: 'GET',
            headers: {
               'Content-Type': 'application/json',
               Authorization: 'Bearer ' + sessionStorage.getItem('token'),
            },
         }
      )
         .then((res) => res.json())
         .then(
            (result) => {
               if (result[0][0]) {
                  console.log(result[0])
                  unblockFriendHandler(result[0][0].id)
               } else {
                  unblock_connectionID(user2, user1)
               }
            },
            (error) => {
               console.log('error: username not found')
            }
         )
   }
   // right now I have it so when a user unblocks the connection is completely removed
   // could change in future depending on how we want to handle unblock
   const unblockFriendHandler = (connection_ID) => {
      fetch(
         'https://webdev.cse.buffalo.edu/hci/api/api/deekstra' +
            '/connections/' +
            connection_ID,
         {
            method: 'DELETE',
            headers: {
               'Content-Type': 'application/json',
               Authorization: 'Bearer ' + sessionStorage.getItem('token'),
            },
         }
      )
         .then((result) => {
            console.log('Success:')
         })
         .catch((error) => {
            console.error('Error:')
         })
   }

   const unblockUser = async (username) => {
      //const test_username = "testfriend2"
      await unblock_UserID(username)
      setTimeout(() => {
         refreshData()
      }, 100)
   }

   let navigator = useNavigate()
   const showProfile = async () => {
      console.log(username)
      const data = await get_userInfo(username)
      console.log(data)
      setGuestPageData({
         name: data.attributes.name,
         description: data.attributes.description,
         imageSrc: data.attributes.profile_pic_src,
         username: data.attributes.username,
         id: data.id,
         tags: data.attributes.tags,
      })
      if (data.id == sessionStorage.getItem('user')) {
         setCurrentTab('Profile')
         navigator(`/main/profile`)
      } else {
         navigator(`/main/user/${username}`)
      }
      setShowParticipants(false)
      setShowComments(false)
   }
   // const showProfile = () => {
   //    navigator(`/main/user/${username}`)
   //    setCurrentTab('GuestPage')
   //    setGuestPageData({
   //       name,
   //       description,
   //       imageSrc: image,
   //       username,
   //    })
   // }

   const smallSizeCard = (
      <div className="friendCardSmall">
         <div className="friendCardSmall_avatar">
            <img
               className="activityCard_avatar_image"
               onClick={showProfile}
               src={image}
               alt="avatar"
            />
         </div>
         <div className="friendCard_description">
            <div className="friendCardSmall_description_top">
               <p
                  className="activityCardSmall_description_top_name"
                  onClick={showProfile}
               >
                  {name}
               </p>
            </div>
            <div className="description_alignment">
               <div className="friendCard_description_middle">
                  {(() => {
                     if (description.length > 105) {
                        return description.substring(0, 105) + '...'
                     } else {
                        return description
                     }
                  })()}
               </div>
               <div className="friendCard_actions">
                  {(() => {
                     if (state === 'friends') {
                        return (
                           <>
                              <div
                                 className="icon_friend_actionDiv"
                                 onClick={() => {
                                    removeFriend(username)
                                 }}
                              >
                                 <FontAwesomeIcon
                                    icon={faUserMinus}
                                    className="icon_friend_action"
                                 />
                                 Remove
                              </div>
                              <div className="friendCard_border_button"></div>
                              <div
                                 className="icon_friend_actionDiv"
                                 onClick={() => {
                                    blockUser(username)
                                 }}
                              >
                                 <FontAwesomeIcon
                                    icon={faUserXmark}
                                    className="icon_friend_action"
                                 />
                                 Block
                              </div>
                           </>
                        )
                     } else if (state === 'blockedUsers') {
                        return (
                           <>
                              <div
                                 className="icon_friend_actionDiv"
                                 onClick={() => {
                                    // addFriend(username)
                                    unblockUser(username)
                                 }}
                              >
                                 <FontAwesomeIcon
                                    icon={faUserAltSlash}
                                    className="icon_friend_action"
                                 />
                                 Unblock
                              </div>
                           </>
                        )
                     } else {
                        return (
                           <>
                              <div
                                 className="icon_friend_actionDiv"
                                 onClick={() => {
                                    addFriend(username)
                                 }}
                              >
                                 <FontAwesomeIcon
                                    icon={faUserPlus}
                                    className="icon_friend_action"
                                 />
                                 Add
                              </div>
                              <div className="friendCard_border_button"></div>
                              <div
                                 className="icon_friend_actionDiv"
                                 onClick={() => {
                                    blockUser(username)
                                 }}
                              >
                                 <FontAwesomeIcon
                                    icon={faUserXmark}
                                    className="icon_friend_action"
                                 />
                                 Block
                              </div>
                           </>
                        )
                     }
                  })()}
               </div>
            </div>
         </div>
      </div>
   )

   const fullSizeCard = (
      <div className="friendCard">
         <div className="friendCard_avatar">
            <img
               className="activityCard_avatar_image"
               onClick={showProfile}
               src={image}
               alt="avatar"
            />
         </div>
         <div className="friendCard_description">
            <div className="activityCard_description_top">
               <p
                  className="activityCard_description_top_name"
                  onClick={showProfile}
               >
                  {name}
               </p>
            </div>
            <div className="description_alignment">
               <div className="friendCard_description_middle">
                  {(() => {
                     if (description.length > 105) {
                        return description.substring(0, 105) + '...'
                     } else {
                        return description
                     }
                  })()}
               </div>
               <div className="friendCard_actions">
                  {(() => {
                     if (state === 'friends') {
                        return (
                           <>
                              <div
                                 className="icon_friend_actionDiv"
                                 onClick={() => {
                                    removeFriend(username)
                                 }}
                              >
                                 <FontAwesomeIcon
                                    icon={faUserMinus}
                                    className="icon_friend_action"
                                 />
                                 Remove
                              </div>
                              <div className="friendCard_border_button"></div>
                              <div
                                 className="icon_friend_actionDiv"
                                 onClick={() => {
                                    blockUser(username)
                                 }}
                              >
                                 <FontAwesomeIcon
                                    icon={faUserXmark}
                                    className="icon_friend_action"
                                 />
                                 Block
                              </div>
                           </>
                        )
                     } else if (state === 'blockedUsers') {
                        return (
                           <>
                              <div
                                 className="icon_friend_actionDiv"
                                 onClick={() => {
                                    // addFriend(username)
                                    unblockUser(username)
                                 }}
                              >
                                 <FontAwesomeIcon
                                    icon={faUserAltSlash}
                                    className="icon_friend_action"
                                 />
                                 Unblock
                              </div>
                           </>
                        )
                     } else {
                        return (
                           <>
                              <div
                                 className="icon_friend_actionDiv"
                                 onClick={() => {
                                    addFriend(username)
                                 }}
                              >
                                 <FontAwesomeIcon
                                    icon={faUserPlus}
                                    className="icon_friend_action"
                                 />
                                 Add
                              </div>
                              <div className="friendCard_border_button"></div>
                              <div
                                 className="icon_friend_actionDiv"
                                 onClick={() => {
                                    blockUser(username)
                                 }}
                              >
                                 <FontAwesomeIcon
                                    icon={faUserXmark}
                                    className="icon_friend_action"
                                 />
                                 Block
                              </div>
                           </>
                        )
                     }
                  })()}
               </div>
            </div>
         </div>
      </div>
   )

   if (showSemiSize) {
      return smallSizeCard
   }

   return fullSizeCard
}

FriendCard.defaultProps = {
   description:
      'Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quidem consectetur perferendis culpa totam expedita, voluptatum corrupti voluptates iusto quae, cumque doloribus qui eligendi eos obcaecati molestiae. Dolorum, rerum. Maiores, ratione!',
   name: 'Firstname Lastname',
}

export default FriendCard
